var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { makeStyles } from '@material-ui/core';
import MuiSlider from '@material-ui/core/Slider';
import CustomValueLabel from './ValueLabel';
var useStyles = makeStyles(function (theme) { return ({
    root: {
        color: theme.palette.secondary.main,
        paddingTop: 0,
        paddingBottom: 0,
    },
    rail: {
        height: '4px',
    },
    track: {
        height: '4px',
    },
    thumb: {
        marginTop: '-4px',
    },
    mark: {
        width: '4px',
        height: '4px',
        borderRadius: '2px',
        transform: 'translateX(-2px)',
    },
}); });
var Slider = function (_a) {
    var _b = _a.kind, kind = _b === void 0 ? 'default' : _b, rest = __rest(_a, ["kind"]);
    var classes = useStyles();
    return (React.createElement(MuiSlider, __assign({ classes: kind === 'default' ? classes : undefined, 
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ValueLabelComponent: kind === 'default' ? CustomValueLabel : undefined }, rest)));
};
export default Slider;
//# sourceMappingURL=Slider.js.map